import { httpInstance } from '@/services/httpInstance';

const deleteFeeService = async (FeeId) => {
  let res;
  const endpoint = `/fares/v1/fees/id/${FeeId}`;

  await httpInstance.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deleteFeeService;
